import {
  REQUEST_FOLLOW_USER, FAIL_FOLLOW_USER, SUCCESS_FOLLOW_USER,
  REQUEST_UNFOLLOW_USER, FAIL_UNFOLLOW_USER, SUCCESS_UNFOLLOW_USER,
} from 'shared/actionTypes';

function buildFeedUserIdKeyFromAction(action) {
  const { feedUserType, feedUserRelatedId } = action.payload;
  return `${feedUserType}-${feedUserRelatedId}`;
}

export default function pendingUserFollows(state = [], action) {
  let feedUserIdKey;

  switch (action.type) {
  case REQUEST_FOLLOW_USER:
  case REQUEST_UNFOLLOW_USER:
    feedUserIdKey = buildFeedUserIdKeyFromAction(action);
    return [
      ...state,
      feedUserIdKey,
    ];
  case SUCCESS_FOLLOW_USER:
  case FAIL_FOLLOW_USER:
  case SUCCESS_UNFOLLOW_USER:
  case FAIL_UNFOLLOW_USER:
    feedUserIdKey = buildFeedUserIdKeyFromAction(action);
    const feedUserIdKeyIndex = state.lastIndexOf(feedUserIdKey);
    if (feedUserIdKeyIndex === -1) {
      return state;
    }

    return [
      ...state.slice(0, feedUserIdKeyIndex),
      ...state.slice(feedUserIdKeyIndex + 1),
    ];
  default:
    return state;
  }
}
